import BaseRepository from "@/baseRepository/BaseRepository";
const resource = `/api/v1/contenttypes`;

export default {
    getContentTypes(baseURL = {}, headers = {}, params = {}) {
        return BaseRepository.get(`${resource}/tree`, {
            baseURL,
            headers,
            params,
        });
    },
    getContentTypesActiveTree(baseURL = {}, headers = {}, params = {}) {
        return BaseRepository.get(`${resource}/active-tree`, {
            baseURL,
            headers,
            params,
        });
    },
    addContentType(body, baseURL = {}, headers = {}, params = {}) {
        return BaseRepository.post(`${resource}`, body, {
          baseURL,
          headers,
          params
        });
      },
    editContentTypebyId(id, body, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.put(`${resource}/${id}`, body, {
        baseURL,
        headers,
        params
    });
    },
    deleteContentTypebyId(id, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.delete(`${resource}/${id}`, {
        baseURL,
        headers,
        params
    });
    },
    enableContentTypebyId(id, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.post(`${resource}/${id}/enable`, {}, {
        baseURL,
        headers,
        params
    });
    },
    disableContentTypebyId(id, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.post(`${resource}/${id}/disable`, {}, {
        baseURL,
        headers,
        params
    });
    },
    getContentTypesTree (baseURL = {}, headers = {}, params = {}){
        return BaseRepository.get(`${resource}/tree`, {
            baseURL,
            headers,
            params,
        });
    },
    // getContentTypesById (id, baseURL = {}, headers = {}, params = {}){
    //     return BaseRepository.get(`${resource}/${id}`, {
    //         baseURL,
    //         headers,
    //         params,
    //     });
    // },
    getContentTypesBreadcrumb (id, baseURL = {}, headers = {}, params = {}){
        return BaseRepository.get(`${resource}/${id}/breadcrumb`, {
            baseURL,
            headers,
            params,
        });
    }
};